module.exports = __webpack_public_path__ + "front/img/64.0f90b5b5.jpg";